import FormEngine from '../FormEngine';
import ControlOptions from '../../WorkflowEngine/ControlOptions';
import WorkflowEngineHeader from '../../WorkflowEngine/WorkflowEngineHeader';
import Grid from '@mui/material/Grid';
import { useContext } from 'react';
import { WorkflowEngineContext } from '../../WorkflowEngine/workflowEngineReducer';
import ReadOnlyFooter from './ReadOnlyFooter';
import Stack from '@mui/material/Stack';
import WorkflowSubHeader from '../WorkflowSubHeader';

export default () => {
  const { state } = useContext(WorkflowEngineContext);
  const { isReadOnlyView } = state;

  return (
    <Stack>
      <WorkflowEngineHeader />
      <WorkflowSubHeader />

      <ControlOptions isReadOnlyView={isReadOnlyView} />
      <Grid
        container
        sx={{
          padding: isReadOnlyView
            ? '10px 30px 30px 30px'
            : '10px 90px 30px 90px',
          justifyContent: 'center'
        }}
      >
        <Grid item xs={12}>
          <FormEngine />
        </Grid>
      </Grid>
      {isReadOnlyView && <ReadOnlyFooter />}
    </Stack>
  );
};
